import { Component, OnInit } from '@angular/core';
import { ICON_TYPE } from "../../../../icons/icon.model";

@Component({
  selector: 'app-custom-store-finder-item',
  templateUrl: './custom-store-finder-item.component.html',
  inputs: ['location', 'index'],
  standalone: false
})
export class CustomStoreFinderItemComponent implements OnInit {

  location;
  index;
  iconTypes = ICON_TYPE;
  showInfo: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
